module.exports = __webpack_public_path__ + "img/Logo_Blue.8a1cfabe.png";